<div class="login-page">
  <div class="background-login">
    <div class="shape">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1440 120">
        <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
      </svg>
    </div>
  </div>
  <div id="login" class="pb-5">
    <div class="login">

      <form [formGroup]="loginForm" (ngSubmit)="submitLogin()" class="login-form p-5">
        <div class="form-group">
          <div class="text-center login-effect-text mb-2">
            <span class="login-text" id="login-text-1" [innerHTML]="'t-login-catchphrase' | translate"></span>
            <span class="login-text" id="login-text-2"></span>
          </div>
        </div>
        <div *ngIf="incorrectLogin" class="incorrect-login p-3 my-1 text-center">
          {{'t-wrong-credentials' | translate}}
        </div>
        <div class="form-group">
          <label class="login-label">{{'t-email' | translate}}</label>
          <input type="email" formControlName="email" [ngClass]="{
                        'is-invalid': submited && form['email'].errors
                      }" class="form-control" name="email" id="email">
          <div *ngIf="submited && form['email'].errors" class="invalid-feedback">
            <div *ngIf="form['email'].errors['required']">
              {{'t-validation-email' | translate}}
            </div>
            <div *ngIf="form['email'].errors['email']">
              {{'t-validation-email-2' | translate}}
            </div>
          </div>
          <i class="icon_mail_alt"></i>
        </div>
        <div class="form-group mt-1">
          <label class="login-label">{{'t-password' | translate}}</label>
          <input type="password" [ngClass]="{
                        'is-invalid': submited && form['password'].errors
                      }" formControlName="password" class="form-control" name="password" id="password" value="">
          <div *ngIf="submited && form['password'].errors" class="invalid-feedback">
            <div *ngIf="form['password'].errors['required']">
              {{'t-validation-password' | translate}}
            </div>
          </div>
          <div *ngIf="form['password'].errors" class="invalid-feedback">
            <!-- <div *ngIf="form['password'].errors['invalidCredentials']">

                        </div> -->
            <div *ngIf="form['password'].errors['anyError']">
              {{'t-generic-error' | translate}}
            </div>
          </div>
          <i class="icon_lock_alt"></i>
        </div>
        <div class="mt-1 mb-4 fl-wrap filter-tags clearfix add_bottom_30">
          <div class="float-right mt-1"><a id="forgot" routerLink="/account/change-password">{{'t-forgot-password' |
              translate}}</a></div>
        </div>
        <button class="btn white w-100 submit-button" type="submit" [attr.disabled]="isDisabled ? '' : null">
          <span *ngIf="!isDisabled">{{'t-sign-in' | translate}}</span>
          <span class="d-flex justify-content-center" *ngIf="isDisabled">
            <span class="me-2">
              {{'t-sign-in' | translate}}...
            </span>
            <span class="spinner-border flex-shrink-0" role="status">
              <span class="visually-hidden">{{'t-sign-in' | translate}}...</span>
            </span>
          </span>
        </button>

        <div class="text-center add_top_10 me-1">{{'t-dont-have-account' | translate}}
          <a [routerLink]="['/account/register']"> {{'t-sign-up' | translate}}</a>
        </div>
      </form>
    </div>
  </div>
</div>
